import { ErrorTypes } from '@wix/form-validator';
export const validateBirthdate = _ref => {
  let {
    value,
    target
  } = _ref;
  if (!value) {
    return undefined;
  }
  const date = new Date(value);
  if (date.getFullYear() < 1900) {
    return {
      errorPath: target,
      errorType: ErrorTypes.MIN_VALUE_ERROR,
      errorMessage: ''
    };
  }
  if (date.getTime() > Date.now()) {
    return {
      errorPath: target,
      errorType: ErrorTypes.MAX_VALUE_ERROR,
      errorMessage: ''
    };
  }
  return undefined;
};
//# sourceMappingURL=contacts-birthdate-validation.js.map